import {
  useGetBackProcedimentiIdInfoGenerali,
  useGetBackProcedimentiIdOggettiCollegati,
} from '@framework/api-client/api/backoffice/procedimenti/procedimenti.ts';
import { useMemo } from 'react';

export function useDossier(id: string | null | undefined) {
  const { data, isLoading, isFetching, error } =
    useGetBackProcedimentiIdInfoGenerali(id ?? '<unknown>', {
      query: {
        keepPreviousData: true,
        enabled: !!id,
      },
    });

  const procedure = useMemo(() => {
    return data?.data;
  }, [data?.data]);

  const dossierData = useGetBackProcedimentiIdOggettiCollegati(
    id ?? '<unknown>',
    {
      query: {
        keepPreviousData: true,
        enabled: !!id,
      },
    },
  );

  const sections = useMemo(() => {
    return dossierData.data?.data?.sezioniDati ?? [];
  }, [dossierData.data?.data?.sezioniDati]);

  return {
    procedure,
    sections,
    isLoading: isLoading || dossierData.isLoading,
    isFetching: isFetching || dossierData.isFetching,
    error: error ?? dossierData.error,
  };
}
